import { createFileRoute, redirect } from "@tanstack/react-router";
import { fetchAuthSession } from "aws-amplify/auth";

export const Route = createFileRoute("/")({
  beforeLoad: async () => {
    try {
      const session = await fetchAuthSession();
      if (!session.tokens) throw redirect({ to: "/login" });
    } catch (e) {
      if (e instanceof Error && e.name !== "Error") throw e;
      throw redirect({ to: "/login" });
    }
  },
  component: () => {
    if (
      typeof window !== "undefined" &&
      window.location.pathname !== "/welcome"
    ) {
      window.location.replace("/welcome");
    }
    return null;
  },
});
